import { render, staticRenderFns } from "./waste.vue?vue&type=template&id=5ba1b196&scoped=true&"
import script from "./waste.vue?vue&type=script&lang=js&"
export * from "./waste.vue?vue&type=script&lang=js&"
import style0 from "./waste.vue?vue&type=style&index=0&id=5ba1b196&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba1b196",
  null
  
)

export default component.exports